module.exports = __webpack_public_path__ + "images/1b85e467a6ce28a8a9f9498e70ae355a.png";